import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
    {
        id: "po-07-h7v0-01",
        name: "PO 01 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
        size: [1190, 850],
        style: {},
        slots: [          
            { id: "1", x: 40, y: 242, width: 254, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 430, width: 254, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 242, width: 254, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 430, width: 254, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 655, y: 180, width: 471, height: 322, rotation: 0, imageRotation: 0 },
            { id: "6", x: 655, y: 509, width: 232, height: 160, rotation: 0, imageRotation: 0 },
            { id: "7", x: 895, y: 509, width: 231, height: 160, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-02",
        name: "PO 02 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 61, y: 257, width: 473, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 656, y: 172, width: 233, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 656, y: 344, width: 233, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 656, y: 516, width: 233, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 172, width: 233, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 344, width: 233, height: 164, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 516, width: 233, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-03",
        name: "PO 03 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 44, y: 182, width: 507, height: 360, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 44, y: 549, width: 164, height: 120, rotation: 0, imageRotation: 0 },
            { id: "3", x: 216, y: 549, width: 164, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 388, y: 549, width: 164, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 639, y: 154, width: 507, height: 350, rotation: 0, imageRotation: 0 },
            { id: "6", x: 639, y: 512, width: 250, height: 184, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 512, width: 249, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-04",
        name: "PO 04 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 38, y: 242, width: 519, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 633, y: 241, width: 168, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 633, y: 367, width: 168, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 633, y: 493, width: 168, height: 117, rotation: 0, imageRotation: 0 },
            { id: "5", x: 809, y: 241, width: 168, height: 118, rotation: 0, imageRotation: 0 },
            { id: "6", x: 985, y: 241, width: 168, height: 118, rotation: 0, imageRotation: 0 },
            { id: "7", x: 809, y: 367, width: 344, height: 243, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-05",
        name: "PO 05 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 67, y: 163, width: 525, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 600, y: 163, width: 524, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 67, y: 534, width: 205, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 280, y: 534, width: 205, height: 151, rotation: 0, imageRotation: 0 },
            { id: "5", x: 493, y: 534, width: 205, height: 151, rotation: 0, imageRotation: 0 },
            { id: "6", x: 706, y: 534, width: 205, height: 151, rotation: 0, imageRotation: 0 },
            { id: "7", x: 919, y: 534, width: 205, height: 151, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-06",
        name: "PO 06 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 51, y: 196, width: 267, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 326, y: 196, width: 266, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 600, y: 196, width: 266, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 874, y: 196, width: 266, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 51, y: 396, width: 358, height: 259, rotation: 0, imageRotation: 0 },
            { id: "6", x: 417, y: 396, width: 357, height: 259, rotation: 0, imageRotation: 0 },
            { id: "7", x: 782, y: 396, width: 357, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-07",
        name: "PO 07 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 204, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 354, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 504, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 200, y: 504, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 400, y: 504, width: 191, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 200, y: 204, width: 391, height: 292, rotation: 0, imageRotation: 0 },
            { id: "7", x: 599, y: 204, width: 591, height: 442, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h7v0-08",
        name: "PO 08 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 204, width: 591, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 204, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 599, y: 354, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 504, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 799, y: 504, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 999, y: 504, width: 191, height: 142, rotation: 0, imageRotation: 0 },
            { id: "7", x: 799, y: 204, width: 391, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-09",
        name: "PO 09 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 204, width: 591, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 204, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 799, y: 204, width: 192, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 999, y: 204, width: 191, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 999, y: 354, width: 191, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 999, y: 504, width: 191, height: 142, rotation: 0, imageRotation: 0 },
            { id: "7", x: 599, y: 354, width: 392, height: 292, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-10",
        name: "PO 10 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 46, y: 183, width: 222, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 347, width: 222, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 46, y: 511, width: 222, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 276, y: 183, width: 639, height: 483, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 183, width: 221, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 922, y: 347, width: 221, height: 156, rotation: 0, imageRotation: 0 },
            { id: "7", x: 922, y: 511, width: 221, height: 155, rotation: 0, imageRotation: 0 }
        ],
    }
];